export default "__VITE_ASSET__CetOlspK__"